import { queryOptions } from '@tanstack/react-query';

import * as packagesApi from './packages.api';

/** Packages change rarely — keep them longer than the app default. */
const CATALOG_STALE_TIME = 5 * 60_000;

export const packageKeys = {
  all: ['packages'] as const,
  list: () => [...packageKeys.all, 'list'] as const,
};

export const packageQueries = {
  list: () =>
    queryOptions({
      queryKey: packageKeys.list(),
      queryFn: packagesApi.listPackages,
      staleTime: CATALOG_STALE_TIME,
    }),
};
